/* import __COLOCATED_TEMPLATE__ from './contact-info-form.hbs'; */
import { DOCUMENT_TYPES } from 'client-portal/services/client-portal-tracking';
import { action } from '@ember/object';
import { bannerError, callbackError } from 'client-portal/utils/error-handling';
import { classNames } from '@ember-decorators/component';
import { reads } from '@ember/object/computed';
import { relationshipTypes } from 'client-portal/utils/relationship-types';
import { scrollToValidationError } from 'client-portal/utils/validate-record';
import { service } from '@ember/service';
import { waitForRender } from 'ember-simplepractice/utils/waiters';
import Super from './autosave-form';
import classic from 'ember-classic-decorator';
import stateGroups from 'ember-simplepractice/utils/state-groups';
import styles from './contact-info-form.module.scss';

const ERROR_POINTER_PREFIX = '/data/attributes/demographicsFormAttributes.';

const WORK = 'Work';
const HOME = 'Home';

@classic
@classNames(styles.component)
export default class SiteDocumentsContactInfoForm extends Super {
  @service clientPortalTracking;
  @service session;
  @service currentPractice;
  styles = styles;

  stateGroups = stateGroups;
  emailTypes = [HOME, WORK];
  phoneTypes = ['Mobile', WORK, HOME, 'Fax'];
  sexes = ['Female', 'Male'];
  relationshipStatuses = {
    '': '',
    'Civil union': 'Civil union',
    'Divorced': 'Divorced',
    'Domestic Partnership': 'Domestic partnership',
    'Married': 'Married',
    'Non-monogamous': 'Non-monogamous',
    'In long-term Relationship': 'Partnered',
    'Separated': 'Separated',
    'Single': 'Single',
    'Widowed': 'Widowed',
  };
  employmentStatuses = {
    '': '',
    'Full-Time': 'Full-time',
    'Homemaker': 'Homemaker',
    'Part-Time': 'Part-time',
    'Retired': 'Retired',
    'Self-employed': 'Self-employed',
    'Full-time Student': 'Student (full-time)',
    'Part-time Student': 'Student (part-time)',
    'Unemployed': 'Unemployed',
  };
  insuredRelations = {
    0: 'Client',
    1: 'Client’s Spouse',
    2: 'Client’s Parent',
    3: 'Other',
  };
  emergencyContactTypes = relationshipTypes;

  @reads('model.demographicsForm') demographicsForm;

  @reads('demographicsForm') autosaveRecord;

  @action
  setReminders(attrName, consentAttrName, valueOrEvent) {
    let value = typeof valueOrEvent === 'object' ? valueOrEvent.target.checked : valueOrEvent;
    this.demographicsForm.set(attrName, value);
    if (value) {
      this.demographicsForm.set(consentAttrName, true);
    }
  }

  @action
  setPhoneNumber(attrName, value) {
    this.demographicsForm.set(attrName, value);
  }

  @action
  async editRequest() {
    const savedAutosaveData = this.autosaveRecord.autosaveSerialize();
    await this.refreshRequest();
    this.demographicsForm.autosaveRestore(savedAutosaveData);
    this.set('autosaveData', savedAutosaveData);
  }

  @action
  async nextStep() {
    try {
      if (this.demographicsForm.validations.isInvalid) {
        await waitForRender();
        this.demographicsForm.set('isDirty', true);
        scrollToValidationError();
        return;
      }

      await this.completeRequestTask.perform(this.model, {
        adapterOptions: {
          embed: ['demographicsForm'],
        },
      });

      if (!this.model.isReviewing) {
        this.set('autosaveData', {});
        this.demographicsForm.rollbackAttributes();
      }
    } catch (err) {
      if (!this.demographicsForm) {
        return;
      }

      callbackError(err, message => {
        if (message.status !== '422') {
          let errorTitle = `${this.model.documentTitle} could not be submitted`;
          this.clientPortalTracking.trackErrorOnDocumentsPage(errorTitle, {
            documentType: DOCUMENT_TYPES.DEMOGRAPHICS_FORM,
          });
          bannerError(err, { title: errorTitle });
        }
        return true;
      });

      // Attach nested errors to the demographicsForm
      err.errors.forEach(({ source, title }) => {
        if (!source || source.pointer.indexOf(ERROR_POINTER_PREFIX) !== 0) {
          return;
        }

        let attr = source.pointer.replace(ERROR_POINTER_PREFIX, '');
        this.demographicsForm.errors.add(attr, title);
      });

      await waitForRender();
      scrollToValidationError();
    }
  }
}
